import _default from './Portal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Portal/index.js
// module id = 323
// module chunks = 1